import { zodResolver } from '@hookform/resolvers/zod'
import { useForm, Controller } from 'react-hook-form'
import { z } from 'zod'

import useWatchlists from '@App/hooks/useWatchList'

import { AddToListIcon } from '@App/static/icons/WatchlistIcons'

import { Button } from '../../controls/Button'
import { TextField } from '../../controls/TextField'
import { ModalTypes } from '../modalTypes'
import ModalWrapper from '../ModalWrapper'

import s from './styles.module.scss'

const schema = z.object({
  name: z.string().regex(/[a-zA-Zа-яА-ЯёЁ0-9]/, 'Name must contain at least one letter or number'),
})

type FormData = z.infer<typeof schema>

export const AddWatchlistsModal = ({
  isOpen,
  setIsOpen,
  parent,
  marketIds,
  styles,
}: ModalTypes & { marketIds?: number[] }) => {
  const { create } = useWatchlists({
    showPortfolio: true,
  })

  const {
    control,
    handleSubmit,
    reset,
    formState: { isValid },
  } = useForm<FormData>({
    resolver: zodResolver(schema),
    mode: 'onChange',
    defaultValues: {
      name: '',
    },
  })

  const onSubmit = (data: FormData) => {
    create(data.name, marketIds)
    reset()
    setIsOpen()
  }

  const handleCancel = () => {
    reset()
    setIsOpen()
  }

  return (
    <ModalWrapper isOpen={isOpen} setIsOpen={setIsOpen} parent={parent} styles={styles}>
      <div className={s.container}>
        <form className={s.content} onSubmit={handleSubmit(onSubmit)}>
          <div className={s.top}>
            <AddToListIcon className={s.icon} />
            <div className={s.title}>Create new watchlist</div>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <TextField
                  value={field.value}
                  onChange={(e) => field.onChange(e.target.value.trim())}
                  onBlur={field.onBlur}
                  containerClassName={s.inputContainer}
                  className={s.input}
                  autoFocus
                  cleareable
                />
              )}
            />
          </div>
          <div className={s.bottom}>
            <Button type="button" variant="outlined" onClick={handleCancel}>
              Cancel
            </Button>
            <Button type="submit" disabled={!isValid}>
              Create
            </Button>
          </div>
        </form>
      </div>
    </ModalWrapper>
  )
}
